import React from "react";

import SupportDrawer from "@/app/shared-components/drawer/support-drawer";
import Expander from "@/app/shared-components/expander/expander-component";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

function QuestionDescriptionDrawer({
  drawerData,
  isDrawerOpen,
  setIsDrawerOpen,
}: Readonly<{
  drawerData?: object | null;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (value: boolean) => void;
}>) {
  const { current } = useWizard();
  const expandFirstSupportDrawerItem =
    current.uiElementControls?.expandFirstSupportDrawerItem;
  return (
    <SupportDrawer
      isOpen={isDrawerOpen}
      setOpen={(value) => setIsDrawerOpen(value)}
    >
      <div>
        {drawerData &&
          Object.entries(drawerData).map(([key, expanderData], index) => {
            if (
              expanderData["mgnl:template"] === "quote:components/atom/expander"
            ) {
              return (
                <Expander
                  key={key}
                  {...expanderData}
                  defaultExpanded={expandFirstSupportDrawerItem && index === 0}
                />
              );
            }
            return null;
          })}
      </div>
    </SupportDrawer>
  );
}

export default QuestionDescriptionDrawer;
